import type { Auth0ProviderOptions } from '@auth0/auth0-react';
import { completeFreshSession, isCodeCallbackAtBoot } from '@/auth/freshSession';
import { DiagnosticAuthCache, recordRefreshFamilyIssuance } from '@/auth/refreshTokenDiagnostics';

const CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || 'XXXXXXX';
const DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || 'devagora.us.auth0.com';
const REDIRECT_URL = import.meta.env.VITE_AUTH0_REDIRECT_URL || 'http://localhost:3001';
const AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || 'http://auth.agora.dev';
const authCache = new DiagnosticAuthCache(CLIENT_ID, AUDIENCE);

export const auth0ProviderOptions: Auth0ProviderOptions = {
  domain: DOMAIN,
  clientId: CLIENT_ID,
  authorizationParams: { redirect_uri: REDIRECT_URL, audience: AUDIENCE },
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  cache: authCache,
  sessionCheckExpiryDays: 30,
  authorizeTimeoutInSeconds: 12,
  httpTimeoutInSeconds: 12,
  // Legacy hash callbacks use auth0-js. Code callbacks use the SPA SDK; codes
  // belonging to Mercado Pago must never be consumed by Auth0.
  skipRedirectCallback:
    (window.location.pathname === '/callback' && !isCodeCallbackAtBoot) ||
    window.location.pathname === '/mercado-pago/callback',
  onRedirectCallback: (appState, user) => {
    const completed = completeFreshSession(appState, user?.sub, false);
    if (completed === 'mismatch') throw new Error('auth_account_mismatch');
    // Stamp only the cache entry just written by this code exchange. Other
    // scope combinations can belong to older families in the same browser.
    const hasRefreshToken = recordRefreshFamilyIssuance(CLIENT_ID, AUDIENCE, authCache.lastWrittenRefreshKey);
    if (completed === 'complete' && window.__agoraFreshSessionResult) {
      window.__agoraFreshSessionResult.hasRefreshToken = hasRefreshToken;
    }
    window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
  }
};
